import {ILotByIdDTO, ILotsByIdDTO} from '../../libs/core-api-requests/accounting/lotRequest';
import {
  IActualPricesLotViewDTO,
  IAnalysisLotViewDTO,
  ICreateDocumentsRequest,
  ICreateDocumentsResponse,
  ILotByGoodsViewDTO,
  ILotDTO,
  ILotGtdNumberDto,
  ILotViewDTO,
  IOnlineReserveDTO,
  ISalesReportViewDTO,
  IWithoutSalesReportViewDTO,
} from '../../libs/coreapi-dto/accounting/lot';
import CoreApiService from '../../system/api/coreApiService';
import {DictionaryDataProvider} from './Common/DictionaryDataProvider';
import { CoreApiResponse } from '../../libs/core-api-requests/common';
import { IdTableVariant } from '../../@types/enumsGlobal';
import { playAlertSound } from '../../system/functions/beepSound';

export class LotDataProvider extends DictionaryDataProvider<ILotViewDTO, ILotDTO> {
  private _coreApiService: CoreApiService;

  constructor(coreApiService: CoreApiService) {
    super();
    this._coreApiService = coreApiService;
  }

  getDataRequest(): Promise<IDictionaryRequest<ILotViewDTO, ILotDTO>> {
    return this._coreApiService.lotRequest;
  }

  getView(filter: IViewBody, callback?: (data: ILotViewDTO[], totalCount: number) => void,  report?: (value) => void, signal?: AbortSignal | null): void {
    this._coreApiService.lotRequest.then((r) =>
      r.getView(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount);
        } else {
          throw new Error(e.message.title);
        }
      },report,signal)
    );
  }

  getViewAnalysis(filter: IViewBody, callback?: (data: IAnalysisLotViewDTO[], totalCount: number, allIds?: string[]) => void): void {
    this._coreApiService.lotRequest.then((r) =>
      r.getViewAnalysis(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount, e.data.allIds);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  getViewSalesReport(filter: IViewBody, callback?: (data: ISalesReportViewDTO[], totalCount: number, allIds: string[]) => void): void {
    this._coreApiService.lotRequest.then((r) =>
      r.getViewSalesReport(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount, e.data.allIds);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  getViewWithoutSalesReport(filter: IViewBody, callback?: (data: IWithoutSalesReportViewDTO[], totalCount: number, allIds: string[]) => void): void {
    this._coreApiService.lotRequest.then((r) =>
      r.getViewWithoutSalesReport(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount, e.data.allIds);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  getViewActualPrices(filter: IViewBody, callback?: (data: IActualPricesLotViewDTO[], totalCount: number, allIds: string[]) => void): void {
    this._coreApiService.lotRequest.then((r) =>
      r.getViewActualPrices(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount, e.data.allIds);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  getLatestPrices(filter: IViewBody, callback?: (data: IActualPricesLotViewDTO[], totalCount: number) => void, signal?: AbortSignal | null): void {
    this._coreApiService.lotRequest.then((r) =>
      r.getLatestPrices(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount);
        } else {
          throw new Error(e.message.title);
        }
      }, signal)
    );
  }

  createDocument(reqeust: ICreateDocumentsRequest, callback?: (response: ICreateDocumentsResponse) => void): void {
    this._coreApiService.lotRequest.then((r) =>
      r.createDocument(reqeust, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  createActRevaluation(reqeust: ICreateDocumentsRequest, callback?: (response: ICreateDocumentsResponse) => void): void {
    this._coreApiService.lotRequest.then((r) =>
      r.createActRevaluation(reqeust, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  getViewByGoods(filter: IViewBody, callback?: (data: ILotByGoodsViewDTO[], totalCount: number) => void,  report?: (value) => void, signal?: AbortSignal | null) {
    this._coreApiService.lotRequest.then((r) =>
      r.getViewByGoods(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount);
        } else {
          throw new Error(e.message.title);
        }
      }, report, signal)
    );
  }

  getViewLotsByGoods(filter: IViewBody, callback?: (data: ILotViewDTO[], totalCount: number) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getViewLotsByGoods(filter, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e.data.entities, e.data.totalCount);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  getLotById(idGlobal: string, callback: (data: ILotByIdDTO) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotById(idGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }
  getLotByKiz(kiz: string, callback: (data: ILotByIdDTO) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotByKiz(kiz, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }
  getLotByKizBox(kizBox: string, callback: (data: ILotByIdDTO) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotByKizBox(kizBox, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }

  getListByKizBoxBarcode(
    kizBoxBarcode: string,
    idStoreGlobal: string | null,
    onRemnants: boolean,
    callback: (data: ILotsByIdDTO[]) => void
  ) {
    this._coreApiService.lotRequest.then((r) =>
      r.getListByKizBoxBarcode(kizBoxBarcode, idStoreGlobal, onRemnants, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }

  getLotByGtinSgtin(gtinSgtin: string, idTable: number, callback: (data: ILotByIdDTO) => void, errorCallback?:() => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotByGtinSgtin(gtinSgtin, idTable, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          playAlertSound('danger')
          errorCallback?.()
          throw new Error(e.message.text);
        }
      })
    );
  }

  getListLotByGtinSgtin(gtinSgtin: string, idTable: number, idStoreGlobal : string | null, callback: (data: ILotsByIdDTO[]) => void, errorCallback?:() => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getListLotByGtinSgtin(gtinSgtin, idTable, idStoreGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          playAlertSound('danger')
          errorCallback?.()
          throw new Error(e.message.text);
        }
      })
    );
  }

  getLotByGtinSgtinByStore(gtinSgtin: string, idTable: number, idStoreGlobal: string, callback: (data: ILotByIdDTO) => void, errorCallback?: () => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotByGtinSgtinByStore(gtinSgtin, idTable, idStoreGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          playAlertSound('danger')
          errorCallback?.()
          throw new Error(e.message.text);
        }
      })
    );
  }

  getLotByBarcode(barcode: string, callback: (data: ILotByIdDTO) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotByBarcode(barcode, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }
  getLotByGoodsCode(code: string, callback: (data: ILotDTO[]) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotByGoodsCode(code, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }
  getLotByInternalBarcode(internalBarcode: string, callback: (data: ILotByIdDTO) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.getLotByInternalBarcode(internalBarcode, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }
  findManyByInternalBarcode(internalBarcode: string, callback: (data: ILotsByIdDTO[]) => void, idStoreGlobal?: string | null ) {
    this._coreApiService.lotRequest.then((r) =>
      r.findManyByInternalBarcode(internalBarcode, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      }, idStoreGlobal)
    );
  }


  remain(idLotGlobal: string, idDocumentGlobal: string, callback: (remain: number) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.remain(idLotGlobal, idDocumentGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }

  remains(idGoodsGlobal: string, idStoreGlobal: string, callback: (remains: number) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.remains(idGoodsGlobal, idStoreGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.text);
        }
      })
    );
  }

  onlineReserve(idLotGlobal: string, body: IOnlineReserveDTO, callback: () => void, fallback?:() => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.onlineReserve(idLotGlobal, body, (e) => {
        if (e.respType === 'isCompleted') {
          callback();
        } else {
          fallback?.();
          throw new Error(e.message.title);
        }
      })
    );
  }

  createGtdNumber(idLotGlobal: string, body: ILotGtdNumberDto, callback: (e: CoreApiResponse<null>) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.createGtdNumber(idLotGlobal, body, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e);
        } else {
          callback(e)
          throw new Error(e.message.title);
        }
      })
    );
  }

  attachFinancialSecurity(idLotGlobal: string, idFinancialSecurityGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.attachFinancialSecurity(idLotGlobal, idFinancialSecurityGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e);
        } else {
          callback?.(e)
          throw new Error(e.message.title);
        }
      })
    );
  }

  detachFinancialSecurity(idLotGlobal: string,callback?: (e: CoreApiResponse<null>) => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.detachFinancialSecurity(idLotGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback?.(e);
        } else {
          callback?.(e)
          throw new Error(e.message.title);
        }
      })
    );
  }

  deleteOnlineItemReserve(idLotGlobal: string, idTable: number, idDocument: string, idDocumentItem: string , callback: () => void) {
 this._coreApiService.lotRequest
      .then(r => r.deleteOnlineItemReserve(idLotGlobal, idTable, idDocument,  idDocumentItem, (e) => { if (e.respType === 'isCompleted') {
          callback();
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  deleteOnlineReserve(idDocument: string, callback: () => void) {
    this._coreApiService.lotRequest
         .then(r => r.deleteOnlineReserve(idDocument, (e) => { if (e.respType === 'isCompleted') {
             callback();
           } else {
             throw new Error(e.message.title);
           }
         })
       );
     }

  getByDocument(idDocGlobal: string, callback: (e: ILotDTO[]) => void) {
    this._coreApiService.lotRequest.then((r) => {
      r.getByDocument(idDocGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          throw new Error(e.message.title);
        }
      });
    });
  }

  updateSeries(idLotGlobal: string, idSeriesGlobal: string, callback: () => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.updateSeries(idLotGlobal, idSeriesGlobal, (e) => {
        if (e.respType === 'isCompleted') {
          callback();
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  updateGosContract(idGosContractGlobal: string, body: string[], callback: () => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.updateGosContract(idGosContractGlobal, body, (e) => {
        if (e.respType === 'isCompleted') {
          callback();
        } else {
          throw new Error(e.message.title);
        }
      })
    );
  }

  checkWithdrawalComplete(idLotGlobal: string, callback: (isWithdrawn: boolean) => void, errorCallback?: () => void) {
    this._coreApiService.lotRequest.then((r) =>
      r.checkWithdrawalComplete(idLotGlobal, (e: CoreApiResponse<boolean>) => {
        if (e.respType === 'isCompleted') {
          callback(e.data);
        } else {
          playAlertSound('danger');
          errorCallback?.();
          throw new Error(e.message.title);
        }
      })
    );
  }
}
